import { useCallback, useLayoutEffect, useRef, useState } from 'react';
import { ServerData, useAxios } from './axios';
import useTimeout from './useTimeout';

type EventReponse = ServerData & {
    payload: any;
};

const useServiceEvent = (
    event: number | null,
    callback: (data: EventReponse) => void,
    timeout = 15000,
) => {
    const axiosInstance = useAxios();
    const [version, setVersion] = useState(0);

    const savedCallback = useRef(callback);

    // Remember the latest callback if it changes.
    useLayoutEffect(() => {
        savedCallback.current = callback;
    }, [callback]);

    const forceUpdate = useCallback(
        () => setVersion((_version) => _version + 1),
        [setVersion],
    );

    const timeoutCallback = useCallback(() => {
        if (!event) return;
        axiosInstance
            .get<EventReponse>(`/account/events/${event}`)
            .then(({ data }) => savedCallback.current(data))
            .catch(() => {});
    }, [version, event]);

    useTimeout(timeoutCallback, event ? timeout : null);

    return {
        forceUpdate,
    };
};

export default useServiceEvent;
